import QualityEntityForm from '../components/layouts/QualityEntityForm'

import useQmsDocumentStatuses from '../hooks/useQmsDocumentStatuses'
import useQualityContents from '../hooks/useQualityContents'
import { ENTITY_TYPES } from '../hooks/useQualityEntity';

const QmsDocument = () => {
    const {
        qmsDocumentStatuses,
        qmsDocumentAreas,
        qmsDocumentTypes,
    } = useQmsDocumentStatuses()

    const {
        updateQmsDocument,
        deleteQmsDocument,
        forceReloadQmsDocuments,
    } = useQualityContents()

    return (
        <QualityEntityForm
            entityType={ENTITY_TYPES.QMS_DOCUMENT}
            areaOptions={qmsDocumentAreas}
            typeOptions={qmsDocumentTypes}
            statusOptions={qmsDocumentStatuses}
            hasClassification

            // Callback functions
            onUpdateDocument={updateQmsDocument}
            onForceReloadDocuments={forceReloadQmsDocuments}
            onDelete={deleteQmsDocument}
        />
    )
};

export default QmsDocument
